import { useState } from "react"
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"

import DataTable from "../Common/DataTable"

const ProductList = ({ items, selected, setSelected, toggleActive }) => {
  return (
    <Tabs align="center">
      <TabList position="sticky" top={0} zIndex={10} bg="white">
        <Tab>Fresco</Tab>
        <Tab>Gastronomia</Tab>
        <Tab>Mostarde</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>
          <ProductListTab
            items={items.filter((product) => product.category === "fresco")}
            selected={selected}
            setSelected={setSelected}
            toggleActive={toggleActive}
          />
        </TabPanel>
        <TabPanel>
          <ProductListTab
            items={items.filter((product) => product.category === "gastro")}
            selected={selected}
            setSelected={setSelected}
            toggleActive={toggleActive}
          />
        </TabPanel>
        <TabPanel>
          <ProductListTab
            items={items.filter((product) => product.category === "mostarde")}
            selected={selected}
            setSelected={setSelected}
            toggleActive={toggleActive}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}

const ProductListTab = ({ items, selected, setSelected, toggleActive }) => {
  const [checked, setChecked] = useState([])
  return (
    <DataTable
      rows={items}
      columns={{
        name: {
          label: "Nome",
          expand: true,
        },
        price: {
          label: "Prezzo",
          textAlign: "right",
          render: (item) =>
            `${Number.parseFloat(item.price || 0).toFixed(2)} €`,
        },
        /*priceIn: {
          label: <span>Prezzo&nbsp;in</span>,
        },
        quantityIn: {
          label: <span>Qtà&nbsp;in</span>,
        },*/
      }}
      selected={checked}
      setSelected={setChecked}
      onRowClick={(item) => setSelected(item)}
    />
  )
}

export default ProductList
